'use client';

import { useEffect } from 'react';
import { useTranslations } from 'next-intl';
import { Locale, scriptConfig } from '@headless-workspace/config';
import { ClientEnvKey, useAppLocale, useClientData } from '@headless-workspace/domain/common/client';
import { GlowSkeleton } from '@headless-workspace/glow-ds';
import { Component } from '@headless-workspace/typings';
import { LanguageHelpers } from '@headless-workspace/utils';
import { useScript } from 'usehooks-ts';
import { PlayerOptions } from './PlayerOptions';
import styles from './ekoo-custom.module.css';
import { useAudioPlayer } from './useAudioPlayer';

type ProductDetailAudioContainerProps = {
    masterProductId: string;
};

const AUDIO_CONTAINER_ID = 'standalone-audio-player';

export const ProductDetailAudioContainer: Component<ProductDetailAudioContainerProps> = ({ masterProductId }) => {
    const locale = useAppLocale();

    const t = useTranslations('Discover.Pdp.information.audio');

    const { getClientEnvVariable } = useClientData();

    const status = useScript(scriptConfig.AudioPlayer.url, {
        removeOnUnmount: true,
        id: scriptConfig.AudioPlayer.id,
    });

    useAudioPlayer();

    useEffect(() => {
        if (status !== 'loading') return;

        const initializePlayerOptions = () => {
            window.ekooOptions = PlayerOptions(
                LanguageHelpers.parseLanguage(locale) as Locale,
                AUDIO_CONTAINER_ID,
                masterProductId,
                t('mainText'),
                t('secondaryText'),
                getClientEnvVariable(ClientEnvKey.EkooWebsiteId),
            );
        };

        initializePlayerOptions();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [status]);

    if (status === 'loading') {
        return <GlowSkeleton containerClassName={'flex-1 w-full h-full'} itemClassName={'rounded-3.5'} />;
    }

    return <div id={AUDIO_CONTAINER_ID} className={styles.ekooAudioContainer}></div>;
};
